



















































































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import ApolloClient, { serverBase } from "../apollo";
import gql from "graphql-tag";
import sceneFragment from "../fragments/scene";
import actorFragment from "../fragments/actor";
import imageFragment from "../fragments/image";
import studioFragment from "../fragments/studio";
import SceneCard from "../components/SceneCard.vue";
import moment from "moment";
import Lightbox from "../components/Lightbox.vue";
import ImageCard from "../components/ImageCard.vue";
import InfiniteLoading from "vue-infinite-loading";
import IActor from "../types/actor";
import IImage from "../types/image";
import IScene from "../types/scene";
import { movieModule } from "../store/movie";
import movieFragment from "../fragments/movie";
import DVDRenderer from "@/components/DVDRenderer.vue";
import ActorGrid from "@/components/ActorGrid.vue";

@Component({
  components: {
    Lightbox,
    ImageCard,
    InfiniteLoading,
    DVDRenderer,
    ActorGrid,
    SceneCard,
  },
  beforeRouteLeave(_to, _from, next) {
    movieModule.setCurrent(null);
    next();
  },
})
export default class MovieDetails extends Vue {
  actors = [] as IActor[];
  scenes = [] as IScene[];
  images = [] as IImage[];
  lightboxIndex = null as number | null;

  infiniteId = 0;
  page = 0;
  show3d = false;

  frontCoverFile = null as File | null;
  frontCoverDialog = false;

  backCoverFile = null as File | null;
  backCoverDialog = false;

  spineCoverFile = null as File | null;
  spineCoverDialog = false;

  @Watch("currentMovie.actors", { deep: true })
  onActorChange(newVal: any[]) {
    this.actors = newVal;
  }

  @Watch("currentMovie.scenes", { deep: true })
  onSceneChange(newVal: any[]) {
    this.scenes = newVal;
    this.images = [];
    this.infiniteId++;
    this.refreshRating();
    this.refreshLabels();
  }

  uploadFrontCover() {
    if (!this.currentMovie) return;

    ApolloClient.mutate({
      mutation: gql`
        mutation($file: Upload!, $name: String) {
          uploadImage(file: $file, name: $name) {
            ...ImageFragment
          }
        }
        ${imageFragment}
      `,
      variables: {
        file: this.frontCoverFile,
        name: this.currentMovie.name + " (front cover)",
      },
    })
      .then((res) => {
        const image = res.data.uploadImage;
        this.images.unshift(image);
        this.setAsFrontCover(image._id);
        this.frontCoverDialog = false;
        this.frontCoverFile = null;
      })
      .finally(() => {});
  }

  uploadBackCover() {
    if (!this.currentMovie) return;

    ApolloClient.mutate({
      mutation: gql`
        mutation($file: Upload!, $name: String) {
          uploadImage(file: $file, name: $name) {
            ...ImageFragment
          }
        }
        ${imageFragment}
      `,
      variables: {
        file: this.backCoverFile,
        name: this.currentMovie.name + " (back cover)",
      },
    })
      .then((res) => {
        const image = res.data.uploadImage;
        this.images.unshift(image);
        this.setAsBackCover(image._id);
        this.backCoverDialog = false;
        this.backCoverFile = null;
      })
      .finally(() => {});
  }

  uploadSpineCover() {
    if (!this.currentMovie) return;

    ApolloClient.mutate({
      mutation: gql`
        mutation($file: Upload!, $name: String) {
          uploadImage(file: $file, name: $name) {
            ...ImageFragment
          }
        }
        ${imageFragment}
      `,
      variables: {
        file: this.spineCoverFile,
        name: this.currentMovie.name + " (spine cover)",
      },
    })
      .then((res) => {
        const image = res.data.uploadImage;
        this.setAsSpineCover(image._id);
        this.spineCoverDialog = false;
        this.spineCoverFile = null;
      })
      .finally(() => {});
  }

  setAsFrontCover(id: string) {
    if (!this.currentMovie) return;

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: MovieUpdateOpts!) {
          updateMovies(ids: $ids, opts: $opts) {
            frontCover {
              _id
            }
          }
        }
      `,
      variables: {
        ids: [this.currentMovie._id],
        opts: {
          frontCover: id,
        },
      },
    })
      .then((res) => {
        movieModule.setFrontCover(id);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  setAsBackCover(id: string) {
    if (!this.currentMovie) return;

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: MovieUpdateOpts!) {
          updateMovies(ids: $ids, opts: $opts) {
            backCover {
              _id
            }
          }
        }
      `,
      variables: {
        ids: [this.currentMovie._id],
        opts: {
          backCover: id,
        },
      },
    })
      .then((res) => {
        movieModule.setBackCover(id);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  setAsSpineCover(id: string) {
    if (!this.currentMovie) return;

    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!, $opts: MovieUpdateOpts!) {
          updateMovies(ids: $ids, opts: $opts) {
            spineCover {
              _id
            }
          }
        }
      `,
      variables: {
        ids: [this.currentMovie._id],
        opts: {
          spineCover: id,
        },
      },
    })
      .then((res) => {
        movieModule.setSpineCover(id);
      })
      .catch((err) => {
        console.error(err);
      });
  }

  get frontCover() {
    if (!this.currentMovie) return "";

    if (this.currentMovie.frontCover)
      return `${serverBase}/media/image/${
        this.currentMovie.frontCover._id
      }?password=${localStorage.getItem("password")}`;
    return "";
  }

  get backCover() {
    if (!this.currentMovie) return "";

    if (this.currentMovie.backCover)
      return `${serverBase}/media/image/${
        this.currentMovie.backCover._id
      }?password=${localStorage.getItem("password")}`;
    return this.frontCover;
  }

  get spineCover() {
    if (!this.currentMovie) return "";

    if (this.currentMovie.spineCover)
      return `${serverBase}/media/image/${
        this.currentMovie.spineCover._id
      }?password=${localStorage.getItem("password")}`;
    return null;
  }

  readImage(file: File): Promise<string> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (reader.result) resolve(reader.result.toString());
        else reject("File error");
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  removeImage(index: number) {
    ApolloClient.mutate({
      mutation: gql`
        mutation($ids: [String!]!) {
          removeImages(ids: $ids)
        }
      `,
      variables: {
        ids: [this.images[index]._id],
      },
    })
      .then((res) => {
        this.images.splice(index, 1);
        this.lightboxIndex = null;
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {});
  }

  updateImage({ index, key, value }: { index: number; key: string; value: any }) {
    const images = this.images[index];
    images[key] = value;
    Vue.set(this.images, index, images);
  }

  get currentMovie() {
    return movieModule.current;
  }

  get movieDuration() {
    if (this.currentMovie && this.currentMovie.duration)
      return moment().startOf("day").seconds(this.currentMovie.duration).format("H:mm:ss");
    return "";
  }

  async fetchPage() {
    if (!this.currentMovie) return [];

    try {
      const result = await ApolloClient.query({
        query: gql`
          query($query: ImageSearchQuery) {
            getImages(query: $query) {
              items {
                ...ImageFragment
                actors {
                  ...ActorFragment
                  avatar {
                    _id
                    color
                  }
                }
                labels {
                  _id
                  name
                }
                scene {
                  _id
                  name
                }
              }
            }
          }
          ${imageFragment}
          ${actorFragment}
        `,
        variables: {
          query: {
            page: this.page,
            sortDir: "asc",
            sortBy: "addedOn",
            scenes: this.scenes.map((s) => s._id),
          },
        },
      });

      return result.data.getImages.items;
    } catch (err) {
      throw err;
    }
  }

  infiniteHandler($state) {
    this.fetchPage().then((items) => {
      if (items.length) {
        this.page++;
        this.images.push(...items);
        $state.loaded();
      } else {
        $state.complete();
      }
    });
  }

  refreshLabels() {
    if (!this.currentMovie) return;

    ApolloClient.query({
      query: gql`
        query($id: String!) {
          getMovieById(id: $id) {
            labels {
              _id
              name
            }
          }
        }
      `,
      variables: {
        id: this.currentMovie._id,
      },
    }).then((res) => {
      movieModule.setLabels(res.data.getMovieById.labels);
    });
  }

  refreshRating() {
    if (!this.currentMovie) return;

    ApolloClient.query({
      query: gql`
        query($id: String!) {
          getMovieById(id: $id) {
            rating
          }
        }
      `,
      variables: {
        id: this.currentMovie._id,
      },
    }).then((res) => {
      movieModule.setRating(res.data.getMovieById.rating);
    });
  }

  get labelNames() {
    if (!this.currentMovie) return [];
    return this.currentMovie.labels.map((l) => l.name).sort();
  }

  get studioLogo() {
    if (this.currentMovie && this.currentMovie.studio && this.currentMovie.studio.thumbnail)
      return `${serverBase}/media/image/${
        this.currentMovie.studio.thumbnail._id
      }?password=${localStorage.getItem("password")}`;
    return "";
  }

  onLoad() {
    ApolloClient.query({
      query: gql`
        query($id: String!) {
          getMovieById(id: $id) {
            ...MovieFragment
            actors {
              ...ActorFragment
              thumbnail {
                _id
                color
              }
              numScenes
              labels {
                _id
                name
              }
            }
            scenes {
              ...SceneFragment
              actors {
                ...ActorFragment
              }
              studio {
                ...StudioFragment
              }
            }
            studio {
              ...StudioFragment
              thumbnail {
                _id
              }
            }
          }
        }
        ${movieFragment}
        ${sceneFragment}
        ${actorFragment}
        ${studioFragment}
      `,
      variables: {
        id: (<any>this).$route.params.id,
      },
    }).then((res) => {
      movieModule.setCurrent(res.data.getMovieById);
      this.scenes = res.data.getMovieById.scenes;
      this.actors = res.data.getMovieById.actors;
    });
  }

  beforeMount() {
    this.onLoad();
  }
}
